import { render, staticRenderFns } from "./login-email-field.vue?vue&type=template&id=fb5d5884"
import script from "./login-email-field.vue?vue&type=script&lang=js"
export * from "./login-email-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports